import { useCallback, useEffect, useState } from 'react'
import dashboardService from '../../../services/DashboardService.js'
import {
  buildAnalyticsParams,
  getStoredAnalyticsCompany,
  isSystemAdminUser,
  setStoredAnalyticsCompany,
} from './analyticsParams.js'

/**
 * Shared System Admin company filter + date params for analytics pages.
 */
export default function useAnalyticsCompanyScope({
  filter,
  customDates = {},
  extra = {},
} = {}) {
  const [currentUser, setCurrentUser] = useState(null)
  const [companies, setCompanies] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(getStoredAnalyticsCompany)

  useEffect(() => {
    let cancelled = false
    const load = async () => {
      try {
        const user = JSON.parse(sessionStorage.getItem('user') || '{}')
        if (cancelled) return
        setCurrentUser(user)
        if (isSystemAdminUser(user)) {
          const json = await dashboardService.getAllCompanies()
          if (cancelled) return
          setCompanies(json.data || json.companies || [])
        } else if (user) {
          const own = user.company_internal_id || user.company_id
          if (own != null) {
            setSelectedCompany(own)
            setStoredAnalyticsCompany(own)
          }
        }
      } catch (e) {
        console.error('Failed loading analytics company scope', e)
      }
    }
    load()
    return () => {
      cancelled = true
    }
  }, [])

  const handleCompanyChange = useCallback((companyId) => {
    const next = companyId == null || companyId === '' ? 'all' : companyId
    setSelectedCompany(next)
    setStoredAnalyticsCompany(next)
  }, [])

  const params = buildAnalyticsParams({
    filter,
    customDates,
    selectedCompany,
    currentUser,
    extra,
  })

  return {
    currentUser,
    companies,
    selectedCompany,
    handleCompanyChange,
    params,
    isSysAdmin: isSystemAdminUser(currentUser),
    ready: Boolean(currentUser),
  }
}
